// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"ee2437ce","411":"9b1a9771","916":"da3c812b"}[chunkId] + ".chunk.css";
};